import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GuiService } from 'src/app/services/gui.service';
import * as confetti from 'canvas-confetti';


@Component({
  selector: 'vex-workout-completed',
  templateUrl: './workout-completed.component.html',
  styleUrls: ['./workout-completed.component.scss']
})
export class WorkoutCompletedComponent implements OnInit {
  workoutTitle;
  confettiInterval: any;
  workoutImageId;

  constructor(public guiService: GuiService, private activatedRoute: ActivatedRoute, private renderer2: Renderer2, private elementRef: ElementRef) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    this.activatedRoute.queryParams.subscribe(params => {
      if(params['workoutTitle']){
        this.workoutTitle = params['workoutTitle'];
      }
    });


    this.confettiInterval = setInterval(() => {
      this.surprise();

      clearInterval(this.confettiInterval)
    }, 500);

    setTimeout(() => {
      clearInterval(this.confettiInterval)
    }, 3000);
  }

  public surprise(): void {

    const canvas = this.renderer2.createElement('canvas');
    canvas.setAttribute("id","confetti-canvas");

    this.renderer2.appendChild(this.elementRef.nativeElement, canvas);

    const myConfetti = confetti.create(canvas, {
      resize: true
    });

    myConfetti();
    setTimeout(()=>{
      document.getElementById("confetti-canvas").remove();
    }, 3000);
  }
}

